import apiClient from "./axios"
import { downloadAndOpenFile } from "./pdfApi"

export const getAccountDutyPayments = async (params = {}) => {
  const { data } = await apiClient.get("/account-duty-payments", { params })
  return data
}

export const getAccountDutyPayment = async id => {
  const { data } = await apiClient.get(`/account-duty-payments/${id}`)
  return data
}

export const createAccountDutyPayment = async payload => {
  const { data } = await apiClient.post("/account-duty-payments", payload)
  return data
}

export const updateAccountDutyPayment = async ({ id, ...payload }) => {
  const { data } = await apiClient.patch(`/account-duty-payments/${id}`, payload)
  return data
}

export const deleteAccountDutyPayment = async id => {
  const { data } = await apiClient.delete(`/account-duty-payments/${id}`)
  return data
}

export const completeAccountDutyPayment = async id => {
  const { data } = await apiClient.post(`/account-duty-payments/${id}/complete`)
  return data
}

export const downloadDutyPaymentPrint = async (id, { onStart, onEnd } = {}) => {
  await downloadAndOpenFile({
    url: `/account-duty-payments/${id}/print`,
    openInNewTab: true,
    onStart,
    onEnd,
  })
}
